import type { MenuOption } from 'types';
import { MenuType } from 'types';

const getMenuItems = (data: MenuOption, toggle: boolean) => {
  let externalFunction;
  let label;
  let link: string | undefined = undefined;
  switch (data.data.type) {
    case MenuType.FUNCTION:
      externalFunction = Function(data.data.function!);
      label = data.data.label;
      break;
    case MenuType.LINK:
      link = data.data.link;
      label = data.data.label;
      break;
    case MenuType.JSON:
      // eslint-disable-next-line no-case-declarations
      const json = JSON.parse(data.data.function!);
      if (toggle) {
        label = Object.keys(json)[0];
        externalFunction = Function(json[label]);
      } else {
        label = Object.keys(json)[1];
        externalFunction = Function(json[label]);
      }
      break;
  }

  return { externalFunction, label, link };
};
export default getMenuItems;
